// Runs fn once the browser is idle (or ASAP on a tick, on browsers without requestIdleCallback -
// notably Safari) instead of immediately, so non-critical startup work doesn't compete with
// initial paint for a spot in the critical rendering path.
export const runWhenIdle = fn => {
  const requestIdle = window.requestIdleCallback || (cb => setTimeout(cb, 1));
  requestIdle(fn);
};
